import {Chip} from '@ds/components';

import {EXTRA_DELIVERY_STATUS_CONFIG} from '../../../constants';
import {normalizeExtraDeliveryState} from '../../../utils';

type ExtraDeliveryStatusProps = {
  value?: string;
};

const ExtraDeliveryStatus: React.FC<ExtraDeliveryStatusProps> = ({value}) => {
  const status = EXTRA_DELIVERY_STATUS_CONFIG[normalizeExtraDeliveryState(value)];

  return (
    <Chip
      label={status?.label ?? value ?? ''}
      variant="soft"
      color={status?.color ?? 'default'}
      size="sm"
      interactive={false}
    />
  );
};

export default ExtraDeliveryStatus;
